<template>
  <div class="service-container">
    <p class="tips">请添加豆姐微信进行客服问题咨询</p>
    <img src="/static/img/wechat-person.jpeg" alt="" class="code" />
  </div>
</template>

<script>
export default {
  name: 'combo'
}
</script>

<style lang="scss">
.service-container {
  .tips {
    margin-top: 59px;
    font-size: 28px;
    line-height: 40px;
    text-align: center;
  }
  .code {
    display: block;
    margin: 30px auto;
    width: 486px;
    height: 486px;
  }
}
</style>
